<script setup>
import Modal from '@/Jetstream/Modal.vue';

const emit = defineEmits(['close']);

defineProps({
    show: {
        type: Boolean,
        default: false,
    },
    maxWidth: {
        type: String,
        default: '2xl',
    },
    closeable: {
        type: Boolean,
        default: true,
    },
});

const close = () => {
    emit('close');
};
</script>

<template>
    <Modal
        :closeable="closeable"
        :max-width="maxWidth"
        :show="show"
        @close="close"
    >
        <div class="px-6 py-4">
            <div class="text-lg">
                <slot name="title" />
            </div>

            <div class="mt-4">
                <slot name="content" />
            </div>
        </div>

        <div class="bg-gray-500-100 flex flex-row justify-end px-6 py-4 text-right">
            <slot name="footer" />
        </div>
    </Modal>
</template>
